import React, {useEffect, useState} from 'react';
import Header from "../component/Header/Header";
import {LINE_ITEM, scheduleAppt, SERVICE_ITEM, YMM_OSS_STRING} from "../../shared/constantsEN";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import QuantitySelector from "../component/quantitySelector";
import {API_BASE_PATH, OSS_PP, OSS_PROD} from "../../shared/restConstants";
import DealerServices from "./DealerServices";
import {resetSearchQuantities, setServiceOptions} from "../../core/redux/ActionCreator";
import {priceFormat} from "../../shared/util/util";
import Offer from "../component/Offers/offer";
import Analytics from "../../shared/util/analytics";
import DealerInfo from "./DealerInfo";

function Cart() {
    const dispatch = useDispatch();
    let currentDate = new Date();

    const bac = useSelector(state => state.dealerReducer.bac);
    const dealerList = useSelector(state => state.dealerReducer.dealers);
    const brand = useSelector(state => state.appParamsReducer.brand);
    const cart = useSelector(state => state.cartReducer.cart);
    const dealerServices = useSelector(state => state.dealerReducer.dealerServices);
    const enrolledDealer = useSelector(state => state.dealerReducer.dealerEnrollment);
    const serviceOptions = useSelector(state => state.dealerReducer.serviceOptions);
    const year = useSelector(state => state.yearMakeModelReducer.sYear);
    const make = useSelector(state => state.yearMakeModelReducer.sMake);
    const model = useSelector(state => state.yearMakeModelReducer.sModel);
    const adobeFlag = useSelector(state => state.appParamsReducer.adobeScriptLoadFlag);
    const dealerServicesFlag = useSelector(state => state.dealerReducer.dealerServicesFlag);
    const analytics = Analytics();
    const dealerObject = dealerList.find(d => d.bac === bac);
    const [isPriceFailed, setPriceFailed] = useState(false);

    useEffect(() => {
        if (adobeFlag) {
            analytics.trackPage('view-cart');
            // eslint-disable-next-line no-undef
            _satellite.track('view-cart');
            console.log('Analytics Added for Page to DOM: View Cart using JQuery');
        }
        // eslint-disable-next-line
    }, [adobeFlag]);

    useEffect(() => {
        if (dealerServicesFlag) {
            const optionalServices = dealerServices.tireOptions.optionalServices;
            optionalServices.sort((a, b) => a.name > b.name ? 1 : -1);
            optionalServices.forEach(service => {
                service['isChecked'] = false;
                service['isDisabled'] = false;
            });
            dispatch(setServiceOptions(optionalServices));
        }
        // eslint-disable-next-line
    }, [dealerServicesFlag, dispatch]);

    useEffect(() => {
        dispatch(resetSearchQuantities())
    }, [dispatch]);

    useEffect(() => {
       for (const item of cart){
            if(item.priceFailed){
                setPriceFailed(true)
                break
            }
            else setPriceFailed(false)
        }
    },[cart]);

    function DisplaySelection() {
        const selectedTires = cart.map((value, index) =>
            <div className={"pxgold"} key={index}>
                <div className={"flexLayout"}>
                    <div className={"tireImage"}>
                        <img src={API_BASE_PATH + "blob/" + value.imageName} alt="Tire" style={{maxWidth: '144px'}}/>
                    </div>
                    <div className={"gridLayout"}>
                        <div className={"tireBrand"}>{value.brand}</div>
                        <div className={"tireNameCart"}>{value.name}</div>
                        <br/>
                        <div className={"tireBrand"}>{value.tireSize}</div>
                        {value.originalEquipment === true ?
                            <div className={"tireBrand"}>Original Equipment</div> :
                            <div className={"tireBrand"}>Replacement Tire</div>
                        }
                        <div className={"tireBrand"}>{value.tireType}</div>
                    </div>
                </div>
                <div className={'resultDetails'}>
                    <br/>
                    <QuantitySelector brand={cart[index].brand} tireName={cart[index].name} gmPartNum={value.gmPartNum} priceFailed={value.priceFailed}
                                      page='cart'  displayBelow={false}/>
                </div>
            </div>);

        return (
            <div>
                {selectedTires}
            </div>
        );
    }

    function getBrand() {
        if (brand !== '' && brand !== 'cobalt') {
            switch (brand.toUpperCase()) {
                case 'CHEVY':
                    return "theme=CH&makecode=001";
                case 'GMC':
                    return "theme=GM&makecode=012";
                case 'BUICK':
                    return "theme=BU&makecode=004";
                case 'CADILLAC':
                    return "theme=CA&makecode=006";
                default:
                    return "";
            }
        } else if (dealerObject) {
            switch (dealerObject.makeCode) {
                case '001':
                    return "theme=CH&makecode=001";
                case '012':
                    return "theme=GM&makecode=012";
                case '004':
                    return "theme=BU&makecode=004";
                case '006':
                    return "theme=CA&makecode=006";
                default:
                    return "";
            }
        }
    }

    function capitaliseFirstLetter(string) {
        return string.slice(0, 1).toUpperCase() + string.slice(1);
    }

    function sendToOSS() {
        let ossString = 'https:';
        if(process.env.NODE_ENV === 'development'){
            ossString = ossString + OSS_PP;
        }else{
            ossString = ossString + OSS_PROD;
        }

        let ymmString = YMM_OSS_STRING;
        let lineItem = 'lineitems=' + LINE_ITEM;
        let serviceItem = SERVICE_ITEM;
        let lineItems = '';

        if (bac !== '' && year !== '' && make !== '' && model !== '') {
            ymmString = ymmString.replace('{BAC}', bac)
                .replace('{makeCode}', getBrand())
                .replace('{year}', year)
                .replace('{make}', capitaliseFirstLetter(make.toLowerCase()))
                .replace('{model}', capitaliseFirstLetter(model.toLowerCase()));

            if (cart.length !== 0) {
                cart.forEach((item) => {
                    lineItem = lineItem.replace('{quantity}', item.quantity)
                        .replace('{brand}', item.brand)
                        .replace('{name}', item.name)
                        .replace('{gmPartNum}', item.gmPartNum)
                        .replace('{price}', priceFormat(item.price));

                    if (item.installation) {
                        lineItem = lineItem + ' Installation for {installation}/EA.';
                        const tireOptions = dealerServices.tireOptions;
                        if (item.runflat) {
                            lineItem = lineItem.replace('{installation}', priceFormat(tireOptions.installationRunflat));
                        } else {
                            lineItem = lineItem.replace('{installation}', priceFormat(tireOptions.installation));
                        }
                    }
                    lineItems += lineItem;
                    serviceOptions.forEach((service) => {
                        serviceItem = SERVICE_ITEM;
                        if (service.isChecked && service.perTire) {
                            serviceItem = serviceItem.replace('{serviceName}', service.name)
                                .replace('{servicePrice}', priceFormat(service.price));

                            lineItems += serviceItem + ' ';
                        }
                    })
                    //add OSS delimiter and uncomment
                    lineItems += 'ALINE';
                    lineItem = LINE_ITEM;
                });
                serviceOptions.forEach((service) => {
                    serviceItem = SERVICE_ITEM;
                    if (service.isChecked && !service.perTire) {
                        serviceItem = serviceItem.replace('{serviceName}', service.name)
                            .replace('{servicePrice}', priceFormat(service.price));

                        lineItems += serviceItem;
                        lineItems += 'ALINE';
                    }
                })
            }
            //Remove comment below to enable delimiter
            lineItems = lineItems.slice(0,-5);
            ossString = ossString + ymmString + 'service:' + lineItems + '#!/appointment';
            console.log(ossString)
            loadOSS(ossString);
        } else {
            console.log('Oops! something is wrong')
        }
    }

    function loadOSS(ossString) {
        console.log('so long, farewell....Next Stop OSS!');
        console.log('ossString: ' + ossString);
        dispatch(window.open(ossString, "_self"));
    }

    return (
        <>
            <Offer/>
            <br/>
            <Header title='Search Results' page='/searchResult' email/>
            <br/>
            <div className={"containerMargin"} id={"cart"}>
                <div className={'confirmTitle'}>CONFIRM SELECTIONS</div>
                <div className={'confirmSubtitle'}>Review the options selected and schedule an appointment. Tires subject to availability.</div>
                <br/>
                <div className={"desktopFlex"}>
                    <DisplaySelection/>
                    <div className={"summaryInfo"}>
                        <div>
                            <div className={'summaryTitle'}>Summary</div>
                            <div className={'summarySubtitle'}>Price subject to change. Check with dealership on arrival. Quoted {currentDate.toLocaleDateString()}. </div>
                        </div>
                        <br/>
                        <div className={'dealerInfoCart'}>
                            <DealerInfo/>
                        </div>
                        <br/>
                        <div>{enrolledDealer !== "false" ?<>
                                {cart.length !== 0 && dealerServicesFlag && <DealerServices/>}
                            <br/>
                            <div className={'cartButton'}>
                                <button className={'button stat-button-link'} disabled={cart.length === 0 || isPriceFailed}
                                        data-dtm={'cart'}
                                        onClick={sendToOSS}>{scheduleAppt}</button>
                            </div>
                            <br/>
                            <div className={"addMore"}>
                                Multiple tire sizes? <Link to='/searchResult' className={"stat-text-link"} data-dtm={'cart'}>Add more
                                tires</Link>
                            <br/>
                            </div>
                       </>:
                                <div className={'summarySubtitle'}>Contact Dealership for additional services. </div>
                    }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Cart;
